import { Component, OnInit } from "@angular/core";
declare var mixpanel;
@Component({
  selector: "app-clear-storage",
  templateUrl: "./clear-storage.component.html",
  styleUrls: ["./clear-storage.component.scss"],
})
export class ClearStorageComponent implements OnInit {
  constructor() { }
  ngOnInit() {
  }
  clearStorage(): void {
    browserWindow.setTimeout(function () {
      if (mixpanel?.cookie && mixpanel?.cookie?.clear) {
        if (mixpanel?.reset) {
          mixpanel.reset();
        }
        mixpanel.cookie.clear();
      }
      browserWindow.document.body.class = '';
      browserWindow.location.href = "/";
    }, 200);
    AppStorageUtil.clearCookies();
    AppStorageUtil.clear();
    AppStorageUtil.clearSession();
  }
}
